var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BestRecruitLayout',[(_vm.aboutCompany)?_c('Flow',{attrs:{"about-company":_vm.aboutCompany}}):_vm._e(),(_vm.aboutCompany)?_c('Work',{attrs:{"about-company":_vm.aboutCompany}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }